import mod from "-!./Employee.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Employee.js?vue&type=script&lang=js&"